import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';

const DigitalIdCardTypeSelect = ({ handleChange, options, selectedValue, index }) => {
  const updateCard = (card) => {
    if (card !== null) {
      handleChange(card);
    }
  }

  return (
    <Fragment>
      <input name={(index !== null) && `school[digital_id_cards_attributes][${index}][card_type]`}
             defaultValue={selectedValue && selectedValue.value}
             hidden/>
      <SingleSelect
        handleChange={updateCard}
        options={options}
        selectedValue={selectedValue}
        showCheckbox={true}
        placeholderText='Select type'
      />
    </Fragment>
  );
};

DigitalIdCardTypeSelect.propTypes = {
  options: PropTypes.array,
  selectedValue: PropTypes.object,
  index: PropTypes.number
};

DigitalIdCardTypeSelect.defaultProps = {
  options: [{}],
  selectedValue: {},
  index: 0
};

export default DigitalIdCardTypeSelect;
